<template>
  <section>
    <!--券事件绑定-->
    <div class="vip_box_ciuem_jsbh">
      <div class="public-dialog-form">
        <el-form
            ref="voucherRuleForm"
            :rules="voucherRules"
            :model="voucherParams"
            label-width="100px"
        >
          <el-row>
            <el-form-item label="券事件：" prop="eventIds">
              <el-select
                  v-model="voucherParams.eventIds"
                  clearable
                  multiple
                  placeholder="请选择券事件"
                  filterable
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in vipRightList"
                    :key="`${index}`"
                    :label="`${item.eventName}`"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-form-item label="描述：" prop="remarks">
            <el-input
                clearable
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请填写描述"
                v-model="voucherParams.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="resetForm('voucherRuleForm')"
        >重 置</el-button
        >
        <el-button size="medium" type="primary" @click="handleVoucherEdit"
        >提 交</el-button
        >
      </span>
    </div>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";

import {ossUpload} from "@utils/filters/upload";

export default {
  data() {
    return {
      loading: false,
      voucherParams: {}, //弹窗修改数据
      voucherRules: {
        eventIds: [
          {required: true, message: "请选择关联事件", trigger: "change"},
        ],
      }, //表单验证提示
      vipRightList: [], //二级--列表
    };
  },
  created() {
    this.getVipRightList();
    this.getVipCouponEventDetail()
  },
  watch: {

  },
  methods: {
    // 获取绑定的详情
    async getVipCouponEventDetail(){
      let http = "/vipCoupon/event/detail";
      this.loading = true;
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.voucherParams = resData.data
        let arr = []
        if (this.voucherParams.eventIds) {
          this.voucherParams.eventIds.map(item => {
            arr.push(Number(item))
          })
        }
        this.voucherParams.eventIds = arr
      } else {
        this.voucherParams = {}
      }
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     *  get list 字典列表
     */
    async getVipRightList() {
      let http = "/coupon/event/list";
      this.loading = true;
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.vipRightList = resData.data;
      } else {
        this.vipRightList = [];
      }
    },

    handleVoucherEdit() {
      this.$refs.voucherRuleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {

          const {data: resData} = await this.$post(
              "/vipCoupon/save",
              this.voucherParams,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$message.success("操作成功!");
        });
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.vip_box_ciuem_jsbh{
  width: 700px;
}
</style>
